import { ChangeDetectorRef, Component, ComponentRef, ElementRef, ViewChild, ViewContainerRef } from '@angular/core';
import {
  WizBasePopUp,
  WizComponentManager,
  WizEventManager,
} from '@wizeoo/akm-component-lib';
import { PivotFilterExtendedRenderer } from '../../pivot/renderers/filters/pivot-filter-extended.renderer';
import { IWidget, IWidgetFilter } from '../../../../manager/widgets/i-widget';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { ALK_EVENT_TYPE } from '../../../../model/enums';
import { cloneDeep } from 'lodash-es';

@Component({
  // popUp d'édition du grid en mode flat : gestion des emplacements de champs et rendu
  selector: 'freedata-tile-filter-pop',
  templateUrl: './freedata-tile-filter.pop.html',
})
export class FreedataTileFilterPop extends WizBasePopUp {
  
  @ViewChild('containerFilter', { read: ViewContainerRef, static: true }) containerFilter: ViewContainerRef; // zone d'ajout des champs de filtre

  public filterComponents: ComponentRef<PivotFilterExtendedRenderer>[]; // les champs de filtre

  constructor(public elementRef: ElementRef, private _cdRef: ChangeDetectorRef) {
    super();
  }
  // dimensions demandées
  public static width: string = '200px';
  public static height: string = '500px';

  public doSaveFlag: boolean = true;
  public hasChange: boolean = false; // une modif sur la collection

  public resultMap: Map<string, IWidgetFilter> = new Map();

  show(): void {
    super.show();
    // mise à jour d'un filtre du widget
    WizEventManager.addListener(this, this, ALK_EVENT_TYPE.INNER_FILTER_UPDATE, this.innerUpdateFilter);
    setTimeout(() => {
      this.buildFilterDrops();
    }, 0);
  }

  public onHide() {
    WizEventManager.removeListener(this, this, ALK_EVENT_TYPE.INNER_FILTER_UPDATE);
  }

  /** Sauvegarde */
  public save(): void {
    this.callback(this.resultMap);
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.hide();
  }

  private innerUpdateFilter(e: AlkEvent): void {
    let filter: IWidgetFilter = e.data; // le filtre modifié
    this.widget.model.widgetEngine.refreshFilter(filter); 
    let filterKey: string = filter.wcio.cod + filter.wcio.fdvf;
    this.resultMap.set(filterKey, filter);
  }

  /** suppression des combos de filtres (avant changement de step, ou sur retour de pop) */
  private clearFilterDrops(): void {
    this.containerFilter.clear(); // vider le container des favoris
    this.filterComponents = []; // on rince la référence aux filtres
  }

  public get widget(): IWidget {
    return this.datas[0]
  }

  private _filters: Map<string, IWidgetFilter> = null;
  public get filters(): Map<string, IWidgetFilter> {
    if(!this._filters) {
      this._filters = new Map();
      let src: Map<string, IWidgetFilter> = this.datas[1];
      [...src.keys()].forEach(k => {
        // on perd l'instance
        let newF = {...src.get(k)};
        newF.wcio = cloneDeep(newF.wcio);
        if(!!newF.values) {
          newF.values = cloneDeep(newF.values);
        }
        
        this._filters.set(k, newF)
      });
    }
    // cloner les instances pour gestion cancel
    return this._filters;
  }


  /** construction des dropdowns de filtre selon le contexte */
  protected buildFilterDrops() {
    this.clearFilterDrops(); // on rince tout
    
    // construire unique le rendu, pas besoin d'alimenter les collections tant que la drop n'est pas ouverte
    if(this.filters) {
      [...this.filters.values()].forEach((filter: IWidgetFilter) => {
          const meCompo: ComponentRef<any> = WizComponentManager.instance.addChildTo(
            PivotFilterExtendedRenderer,
            this.containerFilter,
            { instanceProperties: { data: filter } }
          );
          this.filterComponents.push(meCompo);
      });
    }
    this._cdRef.markForCheck();
  }


}
